export const stationList = [{
  srNo: '1',
  stageCode: '2',
  stationName: 'Gita Mandir',
  stationType: 'Depot',
  KM: '5',
  toll: true,
  totalAmount: 1,
  ghatt: false,
  ghattAmount: '0',
  state: 'Gujarat'
}, {
  srNo: '2',
  stageCode: '1',
  stationName: 'Paldi',
  stationType: 'Bus Stop',
  KM: '10',
  toll: true,
  totalAmount: 1,
  ghatt: false,
  ghattAmount: 1,
  state: 'Gujarat'
}]

export class InsertandUpdateRouteFilter
{
  public intActionType:number;
  public intRouteID?:number;
  public intParentRouteID?:number;
  public strRouteNo:string;
  public strRouteName:string;
  public strRouteCode:string;
  public intFromStation:number;
  public intToStation:number;
  public strVia:string;
  public strDisplayName:string;
  public intRouteTypeID:number;
  public intRouteDirectionID:number;
  public intRouteCategoryID:number;
  public bTollApply?:boolean;
  public intTollTypeID?:number;
  public bGhatApply?:boolean;fv
  public intGhatTypeID?:number;
  public intOrganizationEntityID:number;
  public intRegionalLanguageID1:number;
  public strRegionalValue1:string;
  public intRegionalLanguageID2?:number;
  public strRegionalValue2:string;
  public intUserID?:number;
  public bActive:boolean;
  public bIsRevenue:boolean;
  public dteEffectiveFrom:string;
  public dteEffectiveTo:string;
  public strRouteHistory:string
  public intCreatedBy:number;
}